var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 18,
    viewBox: "0 0 27 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_455_2280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.777698 1.59692C0.409366 1.99265 0.183594 2.52397 0.183594 3.10719V15.0803C0.183594 15.6674 0.412592 16.202 0.784794 16.5983L9.26288 9.37853L0.777698 1.59692Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2627 1.24338C24.9202 1.02217 24.5131 0.893066 24.0764 0.893066H2.38549C1.94878 0.893066 1.54175 1.02217 1.19922 1.24338L13.231 12.2778L25.2627 1.24338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4136 12.85C13.362 12.8973 13.2962 12.9213 13.2304 12.9213C13.1646 12.9213 13.0995 12.8973 13.0472 12.85L9.66773 9.75095L1.21094 16.9526C1.55089 17.1693 1.95341 17.2951 2.38495 17.2951H24.0759C24.5074 17.2951 24.91 17.1693 25.2499 16.9526L16.7931 9.75031L13.4136 12.8493V12.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1999 9.37853L25.6779 16.5983C26.0501 16.2013 26.2791 15.6674 26.2791 15.0803V3.10719C26.2791 2.52397 26.0534 1.99265 25.685 1.59692L17.1992 9.37853H17.1999Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_455_2280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.0941,
    height: 16.402,
    fill: "white",
    transform: "translate(0.183594 0.893066)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.0242d1ea3a72994810c661020a7d4ea5.svg";
export { ForwardRef as ReactComponent };